import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetAssociationsAction} from '../action';

const tableId = 'userAssociations';

function* execute({payload: {tableDataRequest, userProfileId}}: GetAssociationsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getUserAssociationsPage,
        successAction: adminAction.getAssociationsSuccess,
        tableId,
        pathParams: {
            userProfileId,
        },
    }));
}
/** Runs the admin saga that loads association memberships for the selected user. */
export function* getUserAssociationsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_USER_ASSOCIATIONS', execute);
}
